import { ReactNode } from 'react';

import { Box } from '../../Box';

import useStyles from './FormValidationMessage.styles';

/**
 * Свойства компонента {@link FormValidationMessage}
 */
interface FormValidationMessageProps {
  /**
   * Заголовок сообщения.
   */
  title: string;

  /**
   * Дочерние элементы компонента.
   */
  children: ReactNode | ReactNode[];
}

/**
 * Компонент для отображения сообщения валидации формы.
 *
 * @public
 * @param title - Заголовок сообщения.
 * @param children - Дочерние элементы компонента.
 * @returns  Возвращает элемент с сообщением валидации формы.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link FormValidationMessageProps}
 */
export const FormValidationMessage = ({
  title,
  children,
}: FormValidationMessageProps) => {
  const { classes } = useStyles();

  return (
    <div className={classes.message}>
      <Box
        display="flex"
        flexDirection="column"
        p="16"
        bgcolor="bg.greyscale.primary"
        radius="l"
      >
        <Box mb="4">{title}</Box>
        {children}
      </Box>
    </div>
  );
};
